import { render, staticRenderFns } from "./MtipobultoModals.vue?vue&type=template&id=e63e1d34"
import script from "./MtipobultoModals.vue?vue&type=script&lang=js"
export * from "./MtipobultoModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports